import { createAction } from '@reduxjs/toolkit';
import { IErrorType } from '../../constants/types';
import type { ConnectedPlatformRow, InstagramAutomationStatusPayload } from '../../types/instagramAutomation.types';
import type { InstagramAutomationMediaItem } from '../../types/instagramAutomation.types';
import {
    IConfigureInstagramAutomation,
    ICreateSocialPost,
    IExchangeMetaOAuth,
    IGetConnectedPlatforms,
    IGetInstagramAutomationStatus,
    IGetSocialPost,
    ILoadPostAutomationContext,
    ILoadPostAutomationContextSuccess,
    IPublishSocialPost,
    IPublishSocialPostFlow,
    IListInstagramAutomationPosts,
    IListInstagramAutomationPostsSuccess,
    IPatchSocialPost,
    IPatchSocialPostFail,
    IListInstagramAutomationMedia,
    IBindExistingIgAutomation,
    SocialPostWithAutomation,
    types,
} from './types';

export const getConnectedPlatforms = createAction<IGetConnectedPlatforms>(types.GET_CONNECTED_PLATFORMS);
export const getConnectedPlatformsSuccess = createAction<ConnectedPlatformRow[]>(types.GET_CONNECTED_PLATFORMS_SUCCESS);
export const getConnectedPlatformsFail = createAction<IErrorType>(types.GET_CONNECTED_PLATFORMS_FAIL);

export const getInstagramAutomationStatus = createAction<IGetInstagramAutomationStatus>(
    types.GET_INSTAGRAM_AUTOMATION_STATUS,
);
export const getInstagramAutomationStatusSuccess = createAction<InstagramAutomationStatusPayload>(
    types.GET_INSTAGRAM_AUTOMATION_STATUS_SUCCESS,
);
export const getInstagramAutomationStatusFail = createAction<IErrorType>(types.GET_INSTAGRAM_AUTOMATION_STATUS_FAIL);

export const loadPostAutomationContext = createAction<ILoadPostAutomationContext>(types.LOAD_POST_AUTOMATION_CONTEXT);
export const loadPostAutomationContextSuccess = createAction<ILoadPostAutomationContextSuccess>(
    types.LOAD_POST_AUTOMATION_CONTEXT_SUCCESS,
);
export const loadPostAutomationContextFail = createAction<IErrorType>(types.LOAD_POST_AUTOMATION_CONTEXT_FAIL);

export const getInstagramAutomationOAuthUrl = createAction(types.GET_INSTAGRAM_AUTOMATION_OAUTH_URL);
export const getInstagramAutomationOAuthUrlSuccess = createAction<string>(
    types.GET_INSTAGRAM_AUTOMATION_OAUTH_URL_SUCCESS,
);
export const getInstagramAutomationOAuthUrlFail = createAction<IErrorType>(
    types.GET_INSTAGRAM_AUTOMATION_OAUTH_URL_FAIL,
);

export const exchangeMetaOAuth = createAction<IExchangeMetaOAuth>(types.EXCHANGE_META_OAUTH);
export const exchangeMetaOAuthSuccess = createAction(types.EXCHANGE_META_OAUTH_SUCCESS);
export const exchangeMetaOAuthFail = createAction<IErrorType>(types.EXCHANGE_META_OAUTH_FAIL);

export const createSocialPost = createAction<ICreateSocialPost>(types.CREATE_SOCIAL_POST);
export const createSocialPostSuccess = createAction<SocialPostWithAutomation>(types.CREATE_SOCIAL_POST_SUCCESS);
export const createSocialPostFail = createAction<IErrorType>(types.CREATE_SOCIAL_POST_FAIL);

export const publishSocialPost = createAction<IPublishSocialPost>(types.PUBLISH_SOCIAL_POST);
export const publishSocialPostSuccess = createAction<SocialPostWithAutomation>(types.PUBLISH_SOCIAL_POST_SUCCESS);
export const publishSocialPostFail = createAction<IErrorType>(types.PUBLISH_SOCIAL_POST_FAIL);

export const getSocialPost = createAction<IGetSocialPost>(types.GET_SOCIAL_POST);
export const getSocialPostSuccess = createAction<SocialPostWithAutomation>(types.GET_SOCIAL_POST_SUCCESS);
export const getSocialPostFail = createAction<IErrorType>(types.GET_SOCIAL_POST_FAIL);

export const configureInstagramAutomation = createAction<IConfigureInstagramAutomation>(
    types.CONFIGURE_INSTAGRAM_AUTOMATION,
);
export const configureInstagramAutomationSuccess = createAction<SocialPostWithAutomation>(
    types.CONFIGURE_INSTAGRAM_AUTOMATION_SUCCESS,
);
export const configureInstagramAutomationFail = createAction<IErrorType>(types.CONFIGURE_INSTAGRAM_AUTOMATION_FAIL);

export const publishSocialPostFlow = createAction<IPublishSocialPostFlow>(types.PUBLISH_SOCIAL_POST_FLOW);
export const publishSocialPostFlowSuccess = createAction<SocialPostWithAutomation>(
    types.PUBLISH_SOCIAL_POST_FLOW_SUCCESS,
);
export const publishSocialPostFlowFail = createAction<IErrorType>(types.PUBLISH_SOCIAL_POST_FLOW_FAIL);

export const pollSocialPostUntilSettled = createAction<IGetSocialPost>(types.POLL_SOCIAL_POST_UNTIL_SETTLED);
export const pollSocialPostUntilSettledSuccess = createAction<SocialPostWithAutomation>(
    types.POLL_SOCIAL_POST_UNTIL_SETTLED_SUCCESS,
);
export const pollSocialPostUntilSettledFail = createAction<IErrorType>(types.POLL_SOCIAL_POST_UNTIL_SETTLED_FAIL);

export const resetSocialPostsError = createAction(types.RESET_SOCIAL_POSTS_ERROR);

export const listInstagramAutomationPosts = createAction<IListInstagramAutomationPosts>(
    types.LIST_INSTAGRAM_AUTOMATION_POSTS,
);
export const listInstagramAutomationPostsSuccess = createAction<IListInstagramAutomationPostsSuccess>(
    types.LIST_INSTAGRAM_AUTOMATION_POSTS_SUCCESS,
);
export const listInstagramAutomationPostsFail = createAction<IErrorType>(types.LIST_INSTAGRAM_AUTOMATION_POSTS_FAIL);

export const patchSocialPost = createAction<IPatchSocialPost>(types.PATCH_SOCIAL_POST);
export const patchSocialPostSuccess = createAction<SocialPostWithAutomation>(types.PATCH_SOCIAL_POST_SUCCESS);
export const patchSocialPostFail = createAction<IPatchSocialPostFail>(types.PATCH_SOCIAL_POST_FAIL);

export const listInstagramAutomationMedia = createAction<IListInstagramAutomationMedia>(
    types.LIST_INSTAGRAM_AUTOMATION_MEDIA,
);
export const listInstagramAutomationMediaSuccess = createAction<InstagramAutomationMediaItem[]>(
    types.LIST_INSTAGRAM_AUTOMATION_MEDIA_SUCCESS,
);
export const listInstagramAutomationMediaFail = createAction<IErrorType>(types.LIST_INSTAGRAM_AUTOMATION_MEDIA_FAIL);

export const bindExistingIgAutomation = createAction<IBindExistingIgAutomation>(types.BIND_EXISTING_IG_AUTOMATION);
export const bindExistingIgAutomationSuccess = createAction<SocialPostWithAutomation>(
    types.BIND_EXISTING_IG_AUTOMATION_SUCCESS,
);
export const bindExistingIgAutomationFail = createAction<IErrorType>(types.BIND_EXISTING_IG_AUTOMATION_FAIL);
